import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'

import Outcome from '../../../assets/images/projectportfolio/outcomeimage.webp'
import OutcomeOne from '../../../assets/images/arbventure/approachone.webp'
import OutcomeTwo from '../../../assets/images/arbventure/approachtwo.webp'
import OutcomeThree from '../../../assets/images/arbventure/approachthree.webp'

import colors from '../../theme/color'

type ScreenPosition = 'left' | 'center' | 'right'

type CarouselScreen = {
  id: number
  image: string
  position: ScreenPosition
}

const INITIAL_SCREENS: CarouselScreen[] = [
  {
    id: 1,
    image: OutcomeOne,
    position: 'left',
  },
  {
    id: 2,
    image: OutcomeTwo,
    position: 'center',
  },
  {
    id: 3,
    image: OutcomeThree,
    position: 'right',
  },
]

const screenStyles = {
  left: {
    left: '0.5%',
    y: '10%',
    width: '42%',
    height: '92%',
    opacity: 0.6,
    zIndex: 1,
    rotateY: '22deg',
    rotateX: '-15deg',
    rotate: '-8deg',
  },

  center: {
    left: '20%',
    y: '-5%',
    width: '40%',
    height: '320px',
    opacity: 1,
    zIndex: 3,
    rotateY: '10deg',
    rotateX: '-10deg',
    rotate: '1deg',
  },

  right: {
    left: '60%',
    y: '-10%',
    width: '42%',
    height: '92%',
    opacity: 0.6,
    zIndex: 1,
    rotateY: '-22deg',
    rotateX: '15deg',
    rotate: '8deg',
  },
}

const OutcomeSection = () => {
  const [screens, setScreens] =
    useState<CarouselScreen[]>(INITIAL_SCREENS)

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setScreens((prev) =>
  //       prev.map((screen) => {
  //         if (screen.position === 'left') {
  //           return { ...screen, position: 'center' }
  //         }

  //         if (screen.position === 'center') {
  //           return { ...screen, position: 'right' }
  //         }

  //         return { ...screen, position: 'left' }
  //       }),
  //     )
  //   }, 2500)

  //   return () => clearInterval(interval)
  // }, [])

  return (
    <section className="w-full pt-15 md:pt-32 text-white">

      {/* HEADING */}
      <div className="flex items-center justify-center gap-4 mb-16">

        {/* LEFT LINE */}
        <motion.div
          className="flex items-center -gap-2 mt-4"
          initial={{ x: -150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
        >
          <span
  className="w-2 h-2 rounded-full"
  style={{ backgroundColor: colors.portfolioGreen }}
></span>
          <div className="w-12 md:w-30 h-[1px] bg-gray-100"></div>
        </motion.div>

        {/* HEADING */}
        <motion.h2
          className="text-4xl md:text-5xl lg:text-6xl font-bold font-gilroy "
          style={{ color: colors.portfolioGreen }}
          initial={{ scale: 0.6, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
        >
          Outcome
        </motion.h2>

        {/* RIGHT LINE */}
        <motion.div
          className="flex items-center -gap-2 mt-4"
          initial={{ x: 150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
        >
          <div className="w-12 md:w-30 h-[1px] bg-gray-100"></div>
          <span
  className="w-2 h-2 rounded-full"
  style={{ backgroundColor: colors.portfolioGreen }}
></span>
        </motion.div>

      </div>

      {/* LAPTOP */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        className="relative w-[85%] md:w-[75%] mx-auto"
      >

        {/* SCREEN AREA */}
        {/* <div
          className="absolute  z-10 rounded-[10px]"
          style={{
            left: '18%',
            top: '12%',
            width: '74%',
            height: '48%',
          }}
        >

          <div className="relative w-full h-full">

            {screens.map((screen) => {
              const style = screenStyles[screen.position]

              return (
                <motion.div
                key={screen.id}
                className="absolute top-0 w-[40%] h-full rounded-[8px]"
                animate={{
                  left: style.left,
                  y: style.y,
                  width: style.width,
                  height: style.height,   
                  opacity: style.opacity,
                  zIndex: style.zIndex,
                  rotateY: style.rotateY,
                  rotateX: style.rotateX,
                  rotate: style.rotate,
                }}
                transition={{
                  duration: 0.8,
                }}
                style={{
                  transformStyle: 'preserve-3d',
                  transformPerspective: 1200,
                }}
              >
                <img
                  src={screen.image}
                  alt="Outcome screen"
                  className="w-full h-full object-cover rounded-[8px]"
                />
              </motion.div>
              )
            })}

          </div>

        </div> */}

        {/* LAPTOP FRAME */}
        <img
          src={Outcome}
          alt="Laptop"
          className="relative z-20 w-full"
        />

      </motion.div>

      {/* TEXT */}
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className=" w-[95%] md:max-w-[80%] mx-auto text-center mt-12"
      >
        <p
          className="text-base md:text-xl xl:text-3xl leading-relaxed font-gilroy-medium"
          style={{ color: `${colors.white}B3` }}
        >
          The platform successfully enhanced user engagement by combining
          seamless shopping with a rewarding referral system.
          It improved customer retention, increased order frequency,
          and delivered a smooth experience across all devices.
        </p>
      </motion.div>

    </section>
  )
}

export default OutcomeSection